<template>
    <div class="d-flex align-content-center flex-fill size-fijo">
        <router-link
            :to="{ name: route, params: { event_id, sesion_id, tipo_venta } }"
            v-bind="$attrs"
            class="button large-button effect-button sitecolor-content d-flex align-items-center justify-content-center"
        >
            <span>
                <span>{{ title }}</span>
                <small class="d-block" v-if="subtitle">{{ subtitle }}</small>
            </span>
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'GoToCheckoutButton',
        inheritAttrs: false,
        props: ['title', 'subtitle', 'route', 'event_id', 'sesion_id', 'tipo_venta'],
    }
</script>

<style scoped>
    @media (max-width: 768px) {
        .size-fijo {
            width: 150px !important;
        }
    }
</style>